window.onload = (event) => {
    console.log("hello world")
    const selectElement = document.querySelector("#request-type");
    const messageElement = document.querySelector(".request-type-message");
    const addMessageElement = document.querySelector(".add-combine-message");

const item1 = document.querySelector(".contact-name");
const item2 = document.querySelector(".contact-email");
const item3 = document.querySelector(".contact-message");
const item4 = document.querySelector(".contact__button");

    selectElement.addEventListener("change", (event) => {
        let option = event.target.value;
        console.log(option)
        if (option == 'return-info'){
            messageElement.style.display = 'block';
            item1.style.display = 'none';
            item2.style.display = 'none';
            item3.style.display = 'none';
            item4.style.display = 'none';
        }
        else if (option == 'add-combine'){
            console.log("add combine selected")
            addMessageElement.style.display = 'block';
            item1.style.display = 'none';
            item2.style.display = 'none';
            item3.style.display = 'none';
            item4.style.display = 'none';
        }
        else if (option == 'return-info'){
            console.log("return info selected")
            addMessageElement.style.display = 'block';
            item1.style.display = 'none';
            item2.style.display = 'none';
            item3.style.display = 'none';
            item4.style.display = 'none';
        }
        else{
            messageElement.style.display = 'none';
            addMessageElement.style.display = 'none';
            item1.style.display = 'block';
            item2.style.display = 'block';
            item3.style.display = 'block';
            item4.style.display = 'block';
        }
    });
  };

